import { S } from '../core/game';
import { bus } from '../core/bus';
import { ITEM_ICONS } from '../core/effects';
import { m } from '../i18n';
import { itemInfo } from '../i18n/labels';
import { life, weekSpend } from '../content/money';
import { h } from './dom';
import { isPanelOpen, openPanel, refreshPanel } from './panel';

/** Wallet: pocket / piggy / gift fund, this week's budget bar, a needs-vs-wants donut and a tip. */
export function openWallet(): void {
  openPanel('lifeWallet', () => {
    const t = m().life.wallet;
    const s = S();
    const l = life();
    const w = weekSpend();
    const spent = w.need + w.want;
    const pct = w.budget ? Math.min(100, Math.round((spent / w.budget) * 100)) : 0;
    const over = w.budget > 0 && spent > w.budget;
    const needDeg = spent ? Math.round((w.need / spent) * 360) : 0;
    const tips = t.tips;
    const tip = tips[(s.week * 3 + s.dayIndex) % tips.length];
    return {
      title: t.title,
      className: 'life-wallet',
      body: [
        h(
          'div',
          { class: 'life-pots' },
          pot('🪙', t.pocket, s.coins, 'pocket'),
          pot('🐷', t.piggy, s.money.piggy, 'piggy'),
          pot('🎁', t.gift, l.gift, 'gift'),
          pot('🏦', m().airport.bank.potName, s.money.bank ?? 0, 'bank'),
        ),
        h('h4', null, `📊 ${t.budget}`),
        h(
          'div',
          { class: `life-budget${over ? ' over' : ''}` },
          h('div', { class: 'life-budget-bar' }, h('i', { style: `width:${w.budget ? pct : spent ? 100 : 0}%` })),
          h('small', null, t.spent(spent, w.budget)),
          over ? h('small', { class: 'life-warn' }, `⚠️ ${t.over}`) : null,
        ),
        h('h4', null, `🍩 ${t.donut}`),
        spent
          ? h(
              'div',
              { class: 'life-donut-row' },
              h('div', { class: 'life-donut', style: `--need:${needDeg}deg`, role: 'img', 'aria-label': `${m().life.need} ${w.need}, ${m().life.want} ${w.want}` }, h('span', null, `${spent}🪙`)),
              h(
                'div',
                { class: 'life-legend' },
                h('span', { class: 'need' }, h('i'), `${m().life.need}: ${w.need}🪙`),
                h('span', { class: 'want' }, h('i'), `${m().life.want}: ${w.want}🪙`),
              ),
            )
          : h('p', { class: 'hint' }, t.none),
        h('p', { class: 'hint' }, t.allTime(l.total.need, l.total.want)),
        h('h4', null, `📝 ${t.wishes}`),
        l.wishes.length
          ? h('div', { class: 'chips' }, l.wishes.map((x) => h('span', { class: 'chip small' }, `${ITEM_ICONS[x.item]} ${itemInfo(x.item).name} · ${x.price}🪙`)))
          : h('p', { class: 'hint' }, t.noWishes),
        h('p', { class: 'hint' }, t.quiz(l.nwRight)),
        h('div', { class: 'life-tip' }, h('b', null, t.tip), h('span', null, tip)),
      ],
    };
  });
}

function pot(icon: string, label: string, n: number, cls: string): HTMLElement {
  return h('div', { class: `life-pot ${cls}` }, h('span', { class: 'ico' }, icon), h('b', null, String(n)), h('small', null, label));
}

bus.on('change', () => {
  if (isPanelOpen('lifeWallet')) refreshPanel('lifeWallet');
});
